import jsPDF from "jspdf";
import { useUser } from "../../../hooks/useUser";
export const useCertificate = () => {
  const { user } = useUser();

  async function cargarImagenConDimensiones(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    const base64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });

    const img = new Image();
    img.src = base64;

    await new Promise((resolve) => {
      img.onload = resolve;
    });

    return {
      base64,
      width: img.width,
      height: img.height,
    };
  }

  async function generateCertificate({ name, module }) {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "A4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const headerData = await cargarImagenConDimensiones(
      "https://res.cloudinary.com/dfmh8szrj/image/upload/v1749342119/Cabezote_1_irjeym.jpg",
    );
    const footerData = await cargarImagenConDimensiones(
      "https://res.cloudinary.com/dfmh8szrj/image/upload/v1749342119/Cierre_fbbaws.jpg",
    );

    const headerHeight = (headerData.height * pageWidth) / headerData.width;
    const footerHeight = (footerData.height * pageWidth) / footerData.width;

    doc.addImage(headerData.base64, "JPEG", 0, 0, pageWidth, headerHeight);

    // Contenido central
    let cursorY = headerHeight + 40;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(28);
    doc.setTextColor(0, 51, 153); // Azul oscuro
    doc.text("La Escuela en Línea Fleischmann", pageWidth / 2, cursorY, {
      align: "center",
    });

    cursorY += 30;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    const parrafo = [
      "En su búsqueda de hacer que los nuevos conocimientos",
      "y la innovación en pastelería y panadería",
      "llegue a más profesionales en el país",
      "",
      "Hace constar que:",
    ];
    doc.text(parrafo, pageWidth / 2, cursorY, { align: "center" });
    cursorY += 115;

    // Nombre del alumno
    doc.setFont("helvetica", "bold");
    doc.setFontSize(26);
    doc.text(`${user.nombres} ${user.apellidos}`, pageWidth / 2, cursorY, {
      align: "center",
    });
    const textWidth = doc.getTextWidth(`${name}`) + 15;

    const x = pageWidth / 2;
    const startX = x - textWidth / 2;
    const y = 420;
    // Dibujar línea debajo (subrayado)
    const lineY = y + 2; // 2 puntos debajo del texto
    doc.setLineWidth(1);
    doc.line(startX, lineY, startX + textWidth, lineY);

    cursorY += 50;

    // Módulo
    doc.setFont("helvetica", "normal");
    doc.setFontSize(18);
    doc.text(
      "Se ha certificado en nuestro módulo Experto Fleischmann de",
      pageWidth / 2,
      cursorY,
      {
        align: "center",
      },
    );

    doc.setFontSize(22);
    cursorY += 40;
    doc.setFont("helvetica", "bold");
    doc.text(module.toUpperCase(), pageWidth / 2, cursorY, { align: "center" });

    const moduleTextWidth = doc.getTextWidth(`Negocios`) + 15;
    const xModule = pageWidth / 2;
    const startXModule = xModule - moduleTextWidth / 2;
    const yModule = 512;
    // Dibujar línea debajo (subrayado)
    const lineYModule = yModule + 2; // 2 puntos debajo del texto
    doc.setLineWidth(1);
    doc.line(
      startXModule,
      lineYModule,
      startXModule + moduleTextWidth,
      lineYModule,
    );

    // Footer
    doc.addImage(
      footerData.base64,
      "JPEG",
      0,
      pageHeight - footerHeight,
      pageWidth,
      footerHeight,
    );

    doc.save("certificado.pdf");
    // const blob = doc.output("blob");
    // const url = URL.createObjectURL(blob);
  }

  // Plantilla de fondo (imagen completa del certificado con las lineas amarillas).
  // Reemplazar por la URL donde quede hospedada (Cloudinary, igual que Cabezote/Cierre).
  const CERTIFICATE_V2_TEMPLATE_URL =
    "https://res.cloudinary.com/ckvowh5m/image/upload/v1789397704/plantilla_certificado_v2.jpg";

  async function generateCertificateV2({ name, module }) {
    // La plantilla trae todo el diseño estatico (panes, logo, textos, firmas y
    // las dos lineas amarillas). Se carga primero para ajustar la pagina a su
    // misma proporcion y evitar deformacion al no coincidir con A4 exacto.
    const templateData = await cargarImagenConDimensiones(
      CERTIFICATE_V2_TEMPLATE_URL,
    );

    const pageWidth = 841.89; // ancho A4 horizontal en pt
    const pageHeight = (templateData.height * pageWidth) / templateData.width;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: [pageWidth, pageHeight],
    });

    // Fondo a pagina completa
    doc.addImage(templateData.base64, "JPEG", 0, 0, pageWidth, pageHeight);

    // Posiciones como fraccion del alto, calibradas a la plantilla.
    // Ajustar si el texto no cae justo sobre las lineas amarillas.
    const NAME_Y = pageHeight * 0.605; // sobre la primera linea (nombre)
    const MODULE_Y = pageHeight * 0.76; // sobre la segunda linea (modulo)

    doc.setTextColor(0, 51, 153); // Azul oscuro Fleischmann

    // Nombre del alumno (centrado sobre la primera linea)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.text(name, pageWidth / 2, NAME_Y, {
      align: "center",
    });

    // Modulo (centrado sobre la segunda linea)
    doc.setFontSize(18);
    doc.text(module.toUpperCase(), pageWidth / 2, MODULE_Y, {
      align: "center",
    });

    doc.save("certificado.pdf");
    // const blob = doc.output("blob");
    // const url = URL.createObjectURL(blob);
  }

  return { generateCertificate, generateCertificateV2 };
};
